import { xor } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { navigateToProjectReports } from '../../../links/index.jsx';
import { selectInitiativeCategories } from '../../../../modules/initiativeCategories.js';

const mapStateToProps = (state) => ({
  initiativeCategoriesGrouped: selectInitiativeCategories(state),
});

function InitiativeCategoriesFilter({
  selectedCategories,
  initiativeCategoriesGrouped,
}) {
  const initiativeCategories = Object.values(
    initiativeCategoriesGrouped
  ).reduce((accumulator, currentArray) => {
    return accumulator.concat(currentArray);
  }, []);
  const selectedCount = selectedCategories.length;

  const filteredCategories = (arr, type) => {
    const categoriesFilteredByType = arr.filter(
      (category) => category.initiativeType === type
    );

    const notArchived = categoriesFilteredByType.filter(
      (item) => !item.archived
    );
    const archivedWithInitiatives = categoriesFilteredByType.filter(
      (item) => item.archived && item.initiativesCount
    );

    return [...notArchived, ...archivedWithInitiatives];
  };

  const categoriesSortedByName = (arr) =>
    arr.sort((a, b) => a.name.localeCompare(b.name));

  const handleSelect = useCallback(
    (category) =>
      navigateToProjectReports({
        categories: category ? xor(selectedCategories, [category]) : [],
      }),
    [selectedCategories]
  );

  const renderMenuItems = useCallback(
    (type) =>
      categoriesSortedByName(
        filteredCategories(initiativeCategories, type)
      ).map((category) => {
        const key = `${type}_${category.id}`;
        return (
          <React.Fragment key={key}>
            <MenuItem
              onSelect={handleSelect}
              active={selectedCategories.includes(category.id)}
              eventKey={category.id}
            >
              {category.name}
            </MenuItem>
          </React.Fragment>
        );
      }),
    [selectedCategories]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Categories</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="initiative-categories-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          <MenuItem header>Communication</MenuItem>
          {renderMenuItems('communication')}
          <MenuItem divider />
          <MenuItem header>Readiness</MenuItem>
          {renderMenuItems('readiness')}
          <MenuItem divider />
          <MenuItem header>Training</MenuItem>
          {renderMenuItems('training')}
          <MenuItem divider />
          <MenuItem header>Sustainment</MenuItem>
          {renderMenuItems('sustainment')}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

InitiativeCategoriesFilter.propTypes = {
  selectedCategories: PropTypes.arrayOf(PropTypes.string),
};

InitiativeCategoriesFilter.defaultProps = {
  selectedCategories: [],
};

export default connect(mapStateToProps)(InitiativeCategoriesFilter);
